'use client'

import { Phone } from 'lucide-react'

import { phoneLeadValue } from '@/lib/lead-value'
import { useSiteSettings } from '@/lib/site-settings-context'
import { formatPhone } from '@/lib/utils'

/**
 * Every tel: link on the site routes through here so phone taps land in the
 * same `generate_lead` bucket Google Ads bids on. Bare `<a href="tel:">` is
 * invisible to both. Taps carry half a lead's value, which is what lets a
 * value-based strategy prefer the quote form without ignoring the phone.
 */
export function usePhoneClickTracker() {
  const { drivewayPrice } = useSiteSettings()
  return () => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
    window.gtag('event', 'generate_lead', {
      currency: 'AUD',
      value: phoneLeadValue(drivewayPrice),
      event_category: 'contact',
      event_label: 'phone_call',
    })
  }
}

export function PhoneLink({
  className,
  showPrefix,
  style,
  onClick,
}: {
  className?: string
  showPrefix?: boolean
  style?: React.CSSProperties
  onClick?: () => void
}) {
  const { phoneNumber, phoneCallPrefix, phoneCallTitle } = useSiteSettings()
  const trackPhoneClick = usePhoneClickTracker()
  return (
    <a
      href={`tel:${phoneNumber}`}
      className={className}
      style={style}
      title={phoneCallTitle}
      onClick={() => {
        trackPhoneClick()
        onClick?.()
      }}
    >
      <Phone className="mr-2 size-4 shrink-0" aria-hidden="true" />
      {showPrefix && phoneCallPrefix}
      {formatPhone(phoneNumber)}
    </a>
  )
}
